import { addDaysToKey, todayInBusiness } from '../lib/business-date';

/**
 * A document's status is derived, not stored.
 *
 * The API keeps dates and a verification stamp; the screen shows a state. The
 * derivation lives here, with the one window that decides when "expiring"
 * begins, so the status badge, the Expiring filter, the summary tile and its
 * "Within 60 days" hint all read the same rule. They disagreed once — the
 * tile counted sixty days and the badge thirty — and a document expiring in
 * six weeks read "Valid" under a filter that claimed to include it.
 */

/** How far ahead a document counts as expiring. */
export const DOCUMENT_EXPIRING_WITHIN_DAYS = 60;

export type DocumentStatus = 'valid' | 'expiring' | 'expired' | 'pending_verification';

/**
 * Whole days on the business calendar, both ends of the window included — the
 * dashboard's rule too. A document is valid through its expiry date; measuring
 * from this instant instead moved the sixtieth day in and out of "expiring"
 * with the time of day, and the dashboard said 7 beside this page's 8.
 */
export function documentStatus(
  row: { verifiedAt: string | null; expiresOn: string | null },
  today: string = todayInBusiness(),
): DocumentStatus {
  if (!row.verifiedAt) return 'pending_verification';
  if (!row.expiresOn) return 'valid';

  const expires = row.expiresOn.slice(0, 10);
  if (expires < today) return 'expired';
  if (expires <= addDaysToKey(today, DOCUMENT_EXPIRING_WITHIN_DAYS)) return 'expiring';
  return 'valid';
}
